Vue.component('hotel-picker', {
	props: ['user', 'teams'],
	template: `

		<div class="dropdown">
	        
	        <div class="dropdown-select" data-toggle="dropdown">
	            {{ currTeam.name }}
	        </div>
			
			<div class="dropdown-menu">
				<a class="dropdown-item" v-for="team in inactive_teams" :href="'/settings/hotels/'+ team.id +'/switch'">

			        <span>
			            {{ team.name }}
			        </span>

			    </a>
		    </div>
	    </div>
	`,

	computed: {
		currTeam() {
			return Spark.state.currentTeam
		},
		inactive_teams() {
			return this.teams.filter(team => Spark.state.currentTeam.id != team.id)
		}
	}
});